import { AdobeMutationHandler } from 'pkg-trinity-client'
import { newRouteChangeHandler, addCabins, removeCabins, switchActiveCabins } from './index'
import { AdobeEvent } from 'pkg-trinity-client'

export type Sender = (event: AdobeEvent) => void

export const mutationToHandler: AdobeMutationHandler = {
      'route/ROUTE_CHANGED': newRouteChangeHandler(),
      'booking/management/addCabin': addCabins(),
      'booking/management/removeCabinByIndex': removeCabins(),
      'booking/management/setActiveCabinByIndex': switchActiveCabins(),
    }
